<template>
	<div class="template formula">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.title}}<span v-show="dataVal.require" class="require">*</span> </label>
			<input class="input_value" v-model="dataVal.value" type="number" />
		</div>
	</div>
</template>

<script>
	export default{
		props:['dataVal']
	}
</script>

<style scoped lang="less">
	@import "../../assets/css/common.css";
</style>
